<template>
<div >
	
<b-navbar 
	v-if="show_menu == 1"
	toggleable="lg" type="light" variant="white" class="border-bottom p-0 mb-3 gold"
>
	<div class="row text-center p-0 m-0">
		<div class="col-2 d-block d-sm-none">
			<b-navbar-toggle target="nav-collapse" class="p-1 m-1"></b-navbar-toggle>
		</div>
		<div class="col-4 col-sm-5">
			<category-dropdown title="All Categories" />
		</div>
		
		
	</div>


	
	
	
	<b-collapse id="nav-collapse" is-nav class="">

		<!-- Right aligned nav items -->
		<b-navbar-nav class="ml-auto">
			
			<div class="row" v-if="show_search == 1 && this.$store.state.profile.status == 1">
				<b-form-input
					id="search_term"
					v-model="search_term"
					type="text"
					required
					placeholder="Search"
					maxlength="150"
					class="col-8 ml-2 mt-2 "
				></b-form-input>
				<b-button class="col-2 m-1 mt-2 p-1 gold" type="button" @click="setSearchTerm()">
					<i class="fas fa-search"></i>
				</b-button>
			</div>

		</b-navbar-nav>
		
	</b-collapse>
</b-navbar>

</div>
</template>

<script>
import CategoryDropdown from './CategoryDropdown.vue';
import * as Cookie from '@/assets/js/cookie.js';

export default {
	name: 'TopNavi',
	components:{ 
		CategoryDropdown,
	},
	props: {
		profile_name: {
			type: String,
		}
	},
	data() {
		return {
			session_id: this.$store.state.session_id,
			search_term: this.$store.state.search_term,
		}
	},
	computed: {
		menu(){
			var menu = {
				items: this.$store.getters.menuGetItems,
			};
			return menu;
		},
		show_menu(){
			var val = 1;
			if(this.$route.name === 'login'){
				val = 0;
			}
			return val;
		},
		show_search(){
			var val = 1;
			if(this.$route.name === 'search_results'){
				val = 0;
			}
			return val;
		},
	},
	methods: {
		logOut(){
			var vars = {
				profile: {
					status: 0
				}
			};
			this.$store.commit("profileSet", vars );
			this.$store.commit("menuSet", { menu: { items: null } } );
			Cookie.deleteCookie("user_session", process.env.VUE_APP_DOMAIN);
			this.$router.push('/login');
		},

		setSearchTerm(){
			this.$store.commit("searchTermSet", { search_term: this.search_term} );
			if(this.$route.name != 'search_results'){
				this.$router.push('/forum/search_results');
			}
			
		}
	},
	mounted() {
	},
	watch: {
		search_term: function(val){
			console.log(val);
		},
		'$route' (val){
			if(val.name === 'categories'){
				this.$store.commit("categorySlugSet", val.params.slug );
				this.$store.commit("categoryActiveSet", val.params.slug );
			}
		},
	}
}  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
